import React from 'react';
import absoluteUrl from '@sls-react/utils/absoluteUrl';
import { useRouter } from '@sls-react/routing';
import Head from 'next/head';

interface Props {
  canonical?: string | null;
}

const DefaultCanonical: React.FC<Props> = ({ canonical }) => {
  const router = useRouter();

  if (canonical) {
    return (
      <Head>
        <link rel="canonical" href={canonical} />
      </Head>
    );
  }

  if (router?.query?.page) {
    return null;
  } else if (router?.query) {
    return (
      <Head>
        <link rel="canonical" href={absoluteUrl(router.asPath.split('?')[0])} />
      </Head>
    );
  } else {
    return null;
  }
};

export default DefaultCanonical;
